import type { Profile, User } from "@fusioncraft/shared";
import { ProfileForm } from "./ProfileForm";

export function Onboarding({
  user,
  onCreated,
  onSignOut,
}: {
  user: User;
  onCreated: (p: Profile) => void;
  onSignOut: () => void;
}) {
  return (
    <div className="onboarding">
      <header className="onboarding-bar">
        <span className="muted">{user.email}</span>
        <button className="btn-link" onClick={onSignOut}>
          Sign out
        </button>
      </header>
      <main className="onboarding-body">
        <h1>Set up your first profile</h1>
        <p className="lede">
          A profile is one run through the game. It keeps its own ledger of discoveries and asks one model to decide
          every fusion. You can make more later and compare how different models think.
        </p>
        <ProfileForm onCreated={onCreated} suggestedName="First run" />
      </main>
    </div>
  );
}
